import axios from 'axios';
import { getCountryCode } from '@/utils/shoplazza';
import { AddCartAdapter } from '@/utils/addCart/createAddCartTracker';
import { getLocal } from '@/utils/storage';
import { safeJsonParse } from '@/utils/safeJsonParse';
import { STORAGE_KEY } from '@/constant/constant';
import { observeResourceRequests } from '@/utils/addCart/core';

export const createShoplazzaAdapter = (): AddCartAdapter => {
  return {
    name: 'shoplazza',
    getExcludedProductIds: () =>
      safeJsonParse<string[]>(
        getLocal(STORAGE_KEY.EXCLUDE_PRODUCT_IDS) ?? '',
        [],
      ),
    fetchSnapshot: async () => {
      const res = await axios.get(
        window?.location?.origin +
          getCountryCode() +
          '/api/cart?promoter=cartpop',
      );
      // 与 master 一致：响应里没有 cart 对象时视为异常（blocked），init 不清状态、触发路径按空车重试
      if (!res?.data?.cart) {
        return { items: [], rawItems: [], blocked: true };
      }
      const items = res.data.cart.line_items || [];
      return {
        items: items.map((item: any) => ({
          id: item.product_id,
          q: item.quantity,
        })),
        rawItems: items,
      };
    },
    detectEvent: (onPossibleAdd) => {
      observeResourceRequests(
        (url) => url.includes('cart/add.js') || url.includes('cart/add'),
        onPossibleAdd,
      );
      document.addEventListener('dj.addToCart', () => {
        setTimeout(() => onPossibleAdd(), 500);
      });
    },
    noChangeFallback: 'always',
    mapLoadPayload: (rawItem) => ({ image: rawItem?.image?.src || '' }),
  };
};
